const labels = {
  All: { 'See the offering': 'Sehen Sie das Angebot' },
  FacilityDetails: { 'Ref: Page title': 'Details zur Anlage', 'Ref: Review': 'Rezension' },
  FacilitiesList: { 'Ref: Page title': 'Anlagen', 'Ref: See details': 'Siehe Einzelheiten' },
};
export default labels;
